<template>
  <div>
    <h4 class="info-text" style="margin: 10px 0">
      <span class="fa fa-check-circle-o fa-lg" style="color: green"></span>
      Booking Confirmed
    </h4>
    <p class="text-success text-center mb-4">
      Payment is successful and booking is now confirmed
    </p>
    <div class="row justify-content-center">
      <div class="col-sm-6">
        <card style="border: 5px outset">
          <form class="form-horizontal">
            <h5 slot="header" class="card-title text-center">
              Booking # {{ bookingId }}
            </h5>
            <div class="row">
              <label class="col-md-3 col-form-label">Site</label>
              <div class="col-md-9">
                <input
                  type="text"
                  readonly
                  class="form-control-plaintext"
                  id="siteName"
                  :value="siteName"
                />
              </div>

              <label class="col-md-3 col-form-label">Station</label>
              <div class="col-md-9">
                <input
                  type="text"
                  readonly
                  class="form-control-plaintext"
                  id="stationName"
                  :value="statioName"
                />
              </div>

              <label class="col-md-3 col-form-label">Connection</label>
              <div class="col-md-9">
                <input
                  type="text"
                  readonly
                  class="form-control-plaintext"
                  id="connectionName"
                  :value="connectionName"
                />
              </div>
              <label class="col-md-3 col-form-label">Hours Reserved</label>
              <div class="col-md-9">
                <input
                  type="text"
                  readonly
                  class="form-control-plaintext"
                  id="hoursReserved"
                  :value="hoursReserved"
                />
              </div>
              <label class="col-md-3 col-form-label">Total Cost</label>
              <div class="col-md-9">
                <input
                  type="text"
                  readonly
                  class="form-control-plaintext"
                  id="totalCost"
                  :value="totalCost"
                />
              </div>
              <label class="col-md-3 col-form-label">Estimated End Time</label>
              <div class="col-md-9">
                <input
                  type="text"
                  readonly
                  class="form-control-plaintext"
                  id="estimatedEndTime"
                  :value="estimatedEndTime"
                />
              </div>
            </div>
          </form>
        </card>
      </div>
    </div>
    <p class="text-primary text-center mb-4">
      How do you want to send receipt?
    </p>
    <div class="row justify-content-center">
      <div class="col-sm-6">
        <card style="border: 5px outset">
          <form class="form-horizontal">
            <div class="row">
              <div class="col-md-12">
                <fg-input
                  class="col-12"
                  placeholder="Email"
                  addon-left-icon="nc-icon nc-email-85"
                  v-model="email"
                >
                </fg-input>
              </div>
              <!-- <div class="col-md-12">
                  <fg-input class="col-12"
                    placeholder="Text"
                    addon-left-icon="nc-icon nc-chat-33">
                  </fg-input>
                </div> -->
            </div>
          </form>
        </card>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-sm-6">
        <button
          type="button"
          class="btn btn-success btn-block text-center"
          :disabled="!isValidEmail"
          @click="sendReceipt()"
        >
          Send Receipt
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import HTTP from "src/util/http-common.js";

export default {
  name: "payment-confirmation",
  props: {
    summary: {
      type: Object,
      required: true,
    },
    paymentDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      email: "",
    };
  },
  computed: {
    isValidEmail() {
      // Simple email validation using regular expression
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(this.email);
    },
    totalCost() {
      return this.currencyFormatter().format(
        this.summary.inputHours * this.summary.costPerHour +
          this.summary.startUpCost
      );
    },
    siteName() {
      if ("siteInformation" in this.summary) {
        return this.summary.siteInformation.name;
      } else {
        return "";
      }
    },
    statioName() {
      if ("siteInformation" in this.summary) {
        return this.summary.stationDetails.station_number;
      } else {
        return "";
      }
    },
    connectionName() {
      if ("siteInformation" in this.summary) {
        return this.summary.connectionDetails.connection_point;
      } else {
        return "";
      }
    },
    hoursReserved() {
      if ("inputHours" in this.summary) {
        return this.summary.inputHours;
      } else {
        return "";
      }
    },
    estimatedEndTime() {
      return this.paymentDetails.est_end_time_iso;
    },
    bookingId() {
      return this.paymentDetails.booking_id;
    },
  },
  methods: {
    sendReceipt() {
      if (this.isValidEmail && this.paymentDetails.booking_id) {
        let params = {
          email: this.email,
          booking_id: this.paymentDetails.booking_id,
        };
        var loader = this.$loading.show();
        HTTP.post("api/v1/booking/send-receipt", params)
          .then((response) => {
            this.$notify({
              group: "general",
              title: "Success",
              text: "Receipt send Successfully",
              type: "success",
            });
            this.$router.push({
              path: `/bookings/${this.paymentDetails.booking_id}`,
            });
            loader.hide();

            // this.$router.push({path: `bookings/${this.paymentDetails.booking_id}`})
          })
          .catch((err) => {
            loader.hide();
            this.$notify({
              group: "general",
              title: "Error on sending receipt",
              text: err.response.data.error,
              type: "error",
            });
          });
      }
    },
  },
};
</script>
